import axios from "axios";

import { refreshToken } from "Shared/Utils/Domain/Services/RefreshTokenService";
import { toast } from "react-toastify";
import { LOGIN } from "Shared/Routing/Application/Constants/PathsConstant";


export default async function getAPIResponsePrivate(endpoint, data = {}, method = "GET", complete = false, responseType = null) {
	var response = null;
	var params = {};
	try {
		if (method === "GET") {
			params = data;
			data = {};
		}
		response = await axios({
			method: method,
			url: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
			params: params,
			data: data,
			responseType: responseType,
			headers: {
				Authorization: `Bearer ${
					localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)
				}`
			}
		});
		if (complete) {
			return response;
		}
		return response.data;
	} catch (error) {
		try {
			switch (error.response.status) {
				case 401:
				case 403:
					await refreshToken();
					try {
						response = await axios({
							method: method,
							url: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
							params: params,
							data: data,
							responseType: responseType,
							headers: {
								Authorization: `Bearer ${
									localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)
								}`
							}
						});
						if (complete) {
							return response;
						}
						return response.data;
					} catch (error) {
						try{
							switch (error.response.status) {
								case 401:
								case 403:
									window.location.href = process.env.PUBLIC_URL + LOGIN;
									return null;
								default:
									toast.error("Error desconocido");
									return null;
							}
						} catch (error) {
							return null;
						}
					}
				case 400:
					var errors = [];
					for (const [key, value] of Object.entries(error.response.data.errors)) {
						errors.push(<p key={key}>{value}</p>);
					}
					var message = (
						<div>
							<h3>Fallos:</h3>
							{errors}
						</div>
					);
					toast.error(message);
					return null;
				default:
					return null;
			}
		} catch (error) {
			return null;
		}
	}
}
